import type { RootState } from '@/redux';
import type { Prize, User } from '@/services/api/types';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { Langs } from '@CS/components/TranslationProvider/types';

export type { Username, Countries, Langs };
type Username = string | null | undefined;
export const state = {} as UserState;
type Countries = ['nl'][number];

export type UserState = User & {
  participant?: string;
  country?: Countries;
  username: Username;
  firstname?: string;
  lastname?: string;
  language?: Langs;
  error?: unknown;
  points: number;
  prize?: Prize;
};

export const {
  reducer,
  actions: {
    setUserData,
    setUserCountry,
    setParticipantId,
    setUserLanguage,
    setUserPoints,
    setUserPrize
  }
} = createSlice({
  initialState: state,
  name: 'user',
  reducers: {
    setUserData: (state, action: PayloadAction<UserState>) => ({
      ...state,
      ...action.payload
    }),

    setUserCountry: (state, action: PayloadAction<Countries>) => ({
      ...state,
      country: action.payload
    }),

    setParticipantId: (state, action: PayloadAction<string>) => ({
      ...state,
      participant: action.payload
    }),

    setUserLanguage: (state, action: PayloadAction<Langs>) => ({
      ...state,
      language: action.payload
    }),

    setUserPoints: (state, action: PayloadAction<number>) => ({
      ...state,
      points: action.payload
    }),

    setUserPrize: (state, action: PayloadAction<Prize>) => ({
      ...state,
      prize: action.payload
    })
  }
});

export const getUser = (state: RootState) => state.user;

export const getUserId = (state: RootState) => state.user.id;

export const getUserEmail = (state: RootState) => state.user.email;

export const getUserPrize = (state: RootState) => state.user.prize;

export const getUserTeamId = (state: RootState) => state.user.teamId;

export const getUserPoints = (state: RootState) => state.user.points;

export const getUserEntityData = (state: RootState) => state.user.data;

export const getUserUsername = (state: RootState) => state.user.username;

export const getUserLastname = (state: RootState) => state.user.lastname;

export const getUserFirstname = (state: RootState) => state.user.firstname;

export const getUserReadonlyData = (state: RootState) =>
  state.user.readonlyData;
